import { z } from "zod";
import { DeliveryStatus } from "@carry/shared";
import { PublicIdSchema } from "./common";

/**
 * F14: 配送ステータス変更履歴 (通常遷移の追記専用ログ).
 * route_stop の status 変化を時系列で表示する管理画面 Sheet「ステータス履歴」タブで利用。
 */
export const DeliveryStatusHistory = z.object({
  id: PublicIdSchema,
  route_stop_id: PublicIdSchema,
  status: DeliveryStatus,
  comment: z.string().nullable(),
  changed_by: z.object({
    id: PublicIdSchema,
    name: z.string(),
  }),
  changed_at: z.iso.datetime({ offset: true }),
  /** F10 監査連携: ステータス変更時のドライバー GPS 現在地。未取得時は null。 */
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
});

export type DeliveryStatusHistoryDto = z.infer<typeof DeliveryStatusHistory>;
